import { useContext } from "react"

import { RiskZonesStateContext, RiskZonesDispatchContext } from "./RiskZonesContext.context"

export const useRiskZonesStateContext = () => {
    const context = useContext(RiskZonesStateContext)
    if (context === undefined) {
        throw new Error("useRiskZonesStateContext must be used within an RiskZonesStateContext")
    }
    return context
}

export const useRiskZonesDispatchContext = () => {
    const context = useContext(RiskZonesDispatchContext)
    if (context === undefined) {
        throw new Error("useRiskZonesDispatchContext must be used within an RiskZonesDispatchContext")
    }
    return context
}

export const useRiskZonesContext = () => {
    return [useRiskZonesStateContext(), useRiskZonesDispatchContext()]
}